import * as React from "react";
import { Provider } from "react-redux";
import store from "~/store";

export default function createView(componentDefinition: {
    name: string;
    component: React.ComponentType<any>;
}): React.ComponentType<{}> {
    return class View extends React.Component {
        public render() {
            const ViewComponent = componentDefinition.component;
            return (
                <Provider store={store}>
                    <ViewComponent {...this.props} />
                </Provider>
            );
        }
    };
}
